import { IUserData } from 'models/IUserData'
import { useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

interface IExpiredNotifProps {
	userData: IUserData
}

enum HideExpiredNotifEnum {
	CLOSE = 'close',
	SHOW = 'show',
}

export const useShowExpiredNotification = ({
	userData,
}: IExpiredNotifProps) => {
	const dispatch = useAppDispatch()
	const location = useLocation()

	const oneOfLicenseExpired =
		userData.isFatnessExpired ||
		userData.isFoodTableExpired ||
		userData.isIdentificationExpired ||
		userData.isLamenessExpired

	const isClosedBefore =
		localStorage.getItem('expiredLicenseNotifClosed') ===
		HideExpiredNotifEnum.CLOSE

	const setLocalStorage = useCallback(() => {
		localStorage.setItem(
			'expiredLicenseNotifClosed',
			HideExpiredNotifEnum.CLOSE,
		)
	}, [])

	useEffect(() => {
		if (!oneOfLicenseExpired) return

		if (!isClosedBefore) {
			localStorage.setItem(
				'expiredLicenseNotifClosed',
				HideExpiredNotifEnum.SHOW,
			)
			dispatch(
				notifyUser({
					title: 'Данные не актуализируются',
					description:
						'Срок действия одной из лицензий истёк.\nПродлите лицензионное соглашение.',
					isWarning: true,
					handleClose: setLocalStorage,
				}),
			)
		}
	}, [dispatch, isClosedBefore, location, oneOfLicenseExpired, setLocalStorage])
}
